import { createNode } from '@glueapp/graph-types';
import { SlackIntegration } from './SlackIntegration';

export const SendSlackMessage = createNode({
    id: 'Slack: Send Message',
    name: 'Slack: Send Message',
    description: 'Send a message to a slack channel',
    aiDescription:
        'Requires the Slack integration to be connected. Takes a "Channel" (string) input port for the target channel and a "Text" (string) input port for the message content. The channel can also be selected via the slack-channel-selector interface component, which stores the selection in node state as "selectedConversationId". Produces no data outputs, but fires "Success" or "Failure" trigger signals.',
    category: 'Slack',
    color: '#4a154b',
    integration: SlackIntegration,
    inPorts: {
        Channel: { kind: 'string' },
        Text: { kind: 'string' },
    },
    outPorts: {},
    interfaceComponentId: 'slack-channel-selector',
    computeShape: input => ({
        inPorts:
            input.state?.conversationFromPort === false ? input.nodeInPorts.filter(port => port.name !== 'Channel') : input.nodeInPorts,
        outPorts: input.nodeOutPorts,
    }),
    isAsync: true,
    execute: async function (input) {
        const text = input.inPorts.Text;

        let channel: string;
        if (input.state.conversationFromPort) {
            channel = input.inPorts.Channel;
        } else {
            channel = input.state.selectedConversationId as string;
        }

        try {
            const response = await input.integration.callIntegration<{ ok: true } | { ok: false; error: any }>({
                url: 'https://slack.com/api/chat.postMessage',
                method: 'post',
                data: { channel, text },
            });
            if (response.data.ok) {
                return { output: { Success: { isTriggerValue: true, running: true }, Failure: { isTriggerValue: true, running: false } } };
            } else {
                return { output: { Success: { isTriggerValue: true, running: false }, Failure: { isTriggerValue: true, running: true } } };
            }
        } catch (e) {
            return { output: { Success: { isTriggerValue: true, running: false }, Failure: { isTriggerValue: true, running: true } } };
        }
    },
});
